import * as React from 'react';
export const IcSetTopBox = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M21.12 8.88C20.56 8.32 19.8 8 19 8H5c-.8 0-1.56.32-2.12.88S2 10.21 2 11v2c0 .8.32 1.56.88 2.12.32.32.7.55 1.12.7v.68c0 .28.23.5.5.5h.99c.28 0 .5-.23.5-.5v-.49h12v.49c0 .28.23.5.5.5h.99c.28 0 .5-.23.5-.5v-.68c.42-.15.8-.38 1.12-.7.56-.56.88-1.33.88-2.12v-2c0-.8-.32-1.56-.88-2.12h.02zm-8.41 3.83A.99.99 0 0112 13c-.2 0-.39-.06-.56-.17-.16-.11-.29-.27-.37-.45a.956.956 0 01-.06-.58c.04-.19.13-.37.27-.51s.32-.23.51-.27a1.014 1.014 0 011.2.99c0 .27-.11.52-.29.71l.01-.01z'
      fill='currentColor'
    />
  </svg>
);
